export const REF_NAME = 'SUPPLIER';
export const REF_PATH = 'supplier';
export const NAME = 'Seller';
